module.exports = __webpack_public_path__ + "wp-content/themes/cm/img/logo.png";